"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionPayloadResponseToJSON = exports.RosettaConstructionPayloadResponseFromJSONTyped = exports.RosettaConstructionPayloadResponseFromJSON = void 0;
const _1 = require("./");
function RosettaConstructionPayloadResponseFromJSON(json) {
    return RosettaConstructionPayloadResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionPayloadResponseFromJSON = RosettaConstructionPayloadResponseFromJSON;
function RosettaConstructionPayloadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unsigned_transaction': json['unsigned_transaction'],
        'payloads': (json['payloads'].map(_1.SigningPayloadFromJSON)),
    };
}
exports.RosettaConstructionPayloadResponseFromJSONTyped = RosettaConstructionPayloadResponseFromJSONTyped;
function RosettaConstructionPayloadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unsigned_transaction': value.unsigned_transaction,
        'payloads': (value.payloads.map(_1.SigningPayloadToJSON)),
    };
}
exports.RosettaConstructionPayloadResponseToJSON = RosettaConstructionPayloadResponseToJSON;
//# sourceMappingURL=RosettaConstructionPayloadResponse.js.map